enum ArticleActionEnum {
	add = 'add',
	delete = 'delete',
	move = 'move',
	select = 'select',
	copy = 'copy',
	rotate = 'rotate'
}

export default ArticleActionEnum;
